// extracted by mini-css-extract-plugin
export default {"headerContainer":"PreviewStep_headerContainer__TYy12","stickerImage":"PreviewStep_stickerImage__G6z9v"};